import {AfterContentInit, ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {NavigationLink} from '../navigation-bar/navigation-link';
import {ProductDetailsNavigationLinkService} from '../navigation-bar/product-details-navigation-link.service';
import {map, Observable, switchMap} from 'rxjs';
import {Product} from '@spartacus/core';
import {CurrentProductService} from '@spartacus/storefront';
import {DcpProductUtilitiesService} from '../../services/dcp-product-utilities.service';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {ProductPageDecoratorService} from '@app/product/services/product-page-decorator.service';
import {ProductEntitlement} from '@dcp/configurator';

@UntilDestroy()
@Component({
  selector: 'dcp-product-details-section',
  template: '',
})
export class ProductDetailsSectionComponent implements OnInit, OnDestroy, AfterContentInit {
  product$: Observable<Product | null>;
  product: Product;
  entitlements: ProductEntitlement[];
  isSapProduct: boolean;
  navLink: NavigationLink = {
    headline: '',
    id: '',
  };

  constructor(
    protected currentProductService: CurrentProductService,
    protected changeDetection: ChangeDetectorRef,
    protected productDetailsNavigationLinkService: ProductDetailsNavigationLinkService,
    protected dcpProductUtilitiesService: DcpProductUtilitiesService,
    protected productPageDecoratorService: ProductPageDecoratorService,
  ) {}

  ngOnInit(): void {
    this.product$ = this.currentProductService.getProduct();
    this.product$.pipe(
      switchMap((product) => {
        return this.productPageDecoratorService.getCtaProductDetermination(product ?? {}).pipe(
          map((ctaProductDetermination) => {
            const entitlements  = ctaProductDetermination?.entitlements;
            return  {product, entitlements}
          })
        )
      }), 
      untilDestroyed(this)
    ).subscribe(({product, entitlements}) => {
      this.product = product ?? {};
      this.entitlements = entitlements;
      this.isSapProduct = this.dcpProductUtilitiesService.isSapProduct(this.product);
      this.prepareData();
      this.changeDetection.detectChanges();
      if (this.isVisible()) {
        this.productDetailsNavigationLinkService.addNavigationLink(this.navLink);
      } else {
        this.productDetailsNavigationLinkService.removeNavigationLink(this.navLink);
      }
    });
  }

  ngOnDestroy(): void {
    this.productDetailsNavigationLinkService.removeNavigationLink(this.navLink);
  }

  ngAfterContentInit(): void {
    this.productDetailsNavigationLinkService.sortByOffset();
  }

  isVisible(): boolean {
    return false;
  }

  prepareData(): void {
    // is being overwritten
  }
}
